import { ID } from '@common/interfaces/id';
import { NzModalRef } from 'ng-zorro-antd/modal';

export class IssueActionModel {
  constructor(public issueId: ID, public modalRef: NzModalRef) {}
}
